import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg className="magnifier" width={20} height={21} fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g
      className="magnifier-group-container"
      stroke={props?.stroke || '#B3B3B3'}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path className="circle" d="M9.464 18.802a8.393 8.393 0 1 0 0-16.785 8.393 8.393 0 0 0 0 16.785Z" fill="#fff" />
      <path className="rod" d="m18.929 19.874-3.524-3.523" />
    </g>
    <defs></defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const Magnifier = memo(ForwardRef);
export default Magnifier;
